/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AutoSuggestProps } from 'components/AutoSuggest'
import type { AutoSuggestCreatableProps } from 'components/AutoSuggestCreatable'
import type { SelectProps } from 'components/TextInputSearchMulti'

import { COLORS } from 'helpers/constants'

export const customStyles = (
  props: AutoSuggestProps | AutoSuggestCreatableProps | SelectProps,
): any => {
  return {
    control: (provided: any, state: any) => ({
      ...provided,
      borderColor: props.isError ? COLORS.PIRATES_RED_LIGHT : COLORS.GRAY_200,
      height: props.height || '36px',
      width: props.fullWidth ? '100%' : '290px',
      '&:hover': {
        borderColor: props.isError
          ? COLORS.PIRATES_RED_LIGHT
          : COLORS.SURFACE_GRAY,
      },
      backgroundColor: state.isDisabled ? COLORS.GRAY_100 : COLORS.WHITE,
      color: state.isDisabled ? COLORS.SMOKE_GRAY : COLORS.ONYX_GRAY,
    }),
    loadingMessage: (provided: any) => ({
      ...provided,
      fontFamily: 'Sarabun',
    }),
    noOptionsMessage: (provided: any) => ({
      ...provided,
      fontFamily: 'Sarabun',
    }),
  }
}
